import { createFileRoute, useLocation } from '@tanstack/react-router'

import { enderecoNovo } from '@/lib/rotas-antigas'
import { usePapeis } from '@/lib/sessao'

import { Redirecionar } from '@/components/layout/redirecionar'

import { SemPermissao } from '@/features/acesso/tela-aviso'

export const Route = createFileRoute('/legado/$')({
  component: Legado,
})

/**
 * Endereços do painel antigo (`/legado/<tela>`), guardados em favoritos e links.
 * Todas as telas já têm página nova: aqui só levamos a pessoa até ela, mantendo
 * os parâmetros do endereço. Endereço desconhecido mostra o aviso de tela não liberada.
 */
function Legado() {
  const { pathname, searchStr } = useLocation()
  const papeis = usePapeis()
  // `/legado` sozinho era o Início do painel antigo: vai para a visão da pessoa.
  if (pathname.replace(/\/+$/, '') === '/legado') return <Redirecionar para="/" />
  const destino = enderecoNovo(pathname.replace(/\/+$/, '') || '/', searchStr, papeis)
  if (destino) return <Redirecionar para={destino} />
  return <SemPermissao endereco={`${pathname}${searchStr}`} />
}
